{{#if isPipelined}}
virtual function void retire_id(logic [{{ interface.idMsbMaxParameter.name }}:0] id);
  int result_q[$] = {{ activeIdQVariable.identifier }}.find_first_index(active_id) with (active_id == id);
  {{ activeIdQVariable.identifier }}.delete(result_q[0]);
endfunction
{{/if}}
